import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { SFCategory, SFMedia } from "@robe/core-types";

export interface ProductDownloadsResponse {
  categories: SFCategory[];
  downloads: SFMedia[];
}

export interface GetProductDownloadsParams {
  productId: string;
}

export const getProductDownloads = (
  core: XcoreCore,
  { productId }: GetProductDownloadsParams,
  timeout?: number
): BaseApiRequest<ProductDownloadsResponse> => core.fetch(`/api/product/${productId}/downloads`, { timeout }).then((res) => res.json());
